import { ref, computed, onMounted, watch, openBlock, createElementBlock, createElementVNode, toDisplayString, createVNode, withCtx, createTextVNode, createCommentVNode } from "vue";
import UikitButton from "./Button.vue.es.js";
import { useCssVar } from "../uikit.utils/useCssVar.es.js";
/* empty css                    */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = {
  key: 0,
  class: "smart-banner"
};
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "info" };
const _hoisted_4 = { class: "title" };
const _hoisted_5 = { class: "type" };
const _hoisted_6 = { class: "price" };
const _hoisted_7 = ["href"];
const KEY = "APP_SMART_BANNER";
const APPS = {
  PERFORMANCE_ALERTS: "PERFORMANCE_ALERTS"
};
const APP_INFOS = {
  [APPS.PERFORMANCE_ALERTS]: {
    title: "Horiz.io Alertes Rendement",
    type: "Investissement locatif",
    price: "Gratuit",
    appleLink: "https://apps.apple.com/us/app/horiz-io-alertes/id1596721394",
    googleLink: " https://play.google.com/store/apps/details?id=com.horizioannonces.android",
    image: "https://is4-ssl.mzstatic.com/image/thumb/Purple126/v4/35/ca/92/35ca92ba-bbbb-10ab-8f71-bdae66571cd7/AppIcon-1x_U007emarketing-0-5-0-85-220.png/540x540bb.jpg"
  }
};
const _sfc_main = {
  __name: "SmartBanner",
  props: {
    app: {
      type: String,
      default: APPS.PERFORMANCE_ALERTS,
      validator(app) {
        return Object.values(APPS).includes(app.toUpperCase());
      }
    }
  },
  setup(__props) {
    const props = __props;
    const platform = ref(null);
    const isDeclined = ref(false);
    const appMargin = useCssVar("--app-margin-top");
    const getPlatform = () => {
      let maxTouchPoints = window.navigator.maxTouchPoints;
      let userAgent = window.navigator.userAgent;
      if (isExcluded()) {
        return null;
      }
      if (/Android/i.test(userAgent)) {
        return "android";
      } else if (!window.MSStream && !/X11|Linux/i.test(userAgent) && maxTouchPoints && maxTouchPoints > 0 || /iPhone|iPad|iPod/i.test(userAgent)) {
        return "ios";
      }
    };
    const isExcluded = () => {
      return /^.*(Version).*Safari/i.test(window.navigator.userAgent);
    };
    const isIos = computed(() => platform.value === "ios");
    const isAndroid = computed(() => platform.value === "android");
    const app = computed(() => APP_INFOS[props.app]);
    const appLink = computed(
      () => {
        var _a, _b;
        return isIos.value ? (_a = app.value) == null ? void 0 : _a.appleLink : isAndroid.value ? (_b = app.value) == null ? void 0 : _b.googleLink : null;
      }
    );
    const init = () => {
      let data = JSON.parse(localStorage.getItem(KEY));
      if (data && data[props.app] && data[props.app].hidden) {
        isDeclined.value = true;
        platform.value = null;
      } else {
        isDeclined.value = false;
        platform.value = getPlatform();
      }
      if (platform.value) {
        appMargin.value = "104px";
      } else {
        appMargin.value = "0px";
      }
    };
    const handleClose = () => {
      let data = JSON.parse(localStorage.getItem(KEY));
      localStorage.setItem(
        KEY,
        JSON.stringify({
          ...data,
          [props.app]: {
            hidden: true,
            time: Date.now()
          }
        })
      );
      isDeclined.value = true;
    };
    onMounted(init);
    watch(
      () => props.app,
      (value, oldValue) => {
        if (value !== oldValue) {
          init();
        }
      }
    );
    watch(isDeclined, (value) => {
      if (value) {
        platform.value = null;
        appMargin.value = "0px";
      }
    });
    return (_ctx, _cache) => {
      return platform.value ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", {
          class: "close",
          onClick: handleClose
        }, " x "),
        createElementVNode("img", {
          class: "logo",
          src: app.value.image,
          alt: "App " + app.value.title,
          loading: "lazy",
          width: "64",
          height: "64"
        }, null, 8, _hoisted_2),
        createElementVNode("div", _hoisted_3, [
          createElementVNode("div", _hoisted_4, toDisplayString(app.value.title), 1),
          createElementVNode("div", _hoisted_5, toDisplayString(app.value.type), 1),
          createElementVNode("div", _hoisted_6, toDisplayString(app.value.price), 1)
        ]),
        createElementVNode("a", {
          class: "action",
          href: appLink.value
        }, [
          createVNode(UikitButton, {
            type: "secondary",
            size: "small"
          }, {
            default: withCtx(() => [
              createTextVNode(" Obtenir ")
            ]),
            _: 1
          })
        ], 8, _hoisted_7)
      ])) : createCommentVNode("", true);
    };
  }
};
const SmartBanner = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-6b6e9c45"]]);
export {
  SmartBanner as default
};
//# sourceMappingURL=SmartBanner.vue.es.js.map
